module.exports = __webpack_public_path__ + "static/img/MITCHELL-STEVENS.efdecc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MITCHELL-STEVENS.jpg
// module id = gsVy
// module chunks = 0